export default {
  ARTICLE_TYPE: 'article',
  HELP_ARTICLE_TYPE: 'help_article',
  PRESS_RELEASE_TYPE: 'pressRelease',
};
